<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Sign-ups" subtitle="See who has registered an interest in volunteering and pre-approve them to access roles." :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-item text="Approve" icon="accept" :success="true" :disabled="!selected.length || is.rejecting" :loading="is.accepting" v-on:click="onAcceptClick" />
		
		<app-content-head-actions-item text="Reject" icon="reject" :danger="true" :disabled="!selected.length || is.accepting" :loading="is.rejecting" v-on:click="onRejectClick" />

		<app-content-head-actions-panel text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" :disabled="!collection.length" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no sign-ups found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column text="Badge" />

				<app-table-column text="About" />

				<app-table-column align="center" text="Submitted on" />

				<app-table-column align="center" text="Decided on" />

				<app-table-column text="Assignments" align="center" />

				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row :noClick="true" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.volunteers.signup.statusName[item.status]" :subtext="item.reference" :type="$constants.volunteers.signup.statusTheme[item.status]" />

					<app-table-cell-item type="convention/badge" :item="item.badge" />

					<app-table-cell-text :text="item.about" />

					<app-table-cell-text align="center" :text="item.date.submitted | localDate('MM/DD/YYYY')" />

					<app-table-cell-text align="center" :text="item.date.decided | localDate('MM/DD/YYYY')" :can-empty="true" />

					<app-table-cell-text :text="(item.status === $constants.volunteers.signup.status.accepted) ? item.assignments : '-'" align="center" />

					<app-table-cell-select v-if="item.status === $constants.volunteers.signup.status.pending" :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />
					<app-table-cell-text v-if="item.status !== $constants.volunteers.signup.status.pending" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			is: {
				accepting: false,
				rejecting: false
			},
			layout: '120px 240px 1fr 115px 115px 115px 40px',
			endpoint: 'convention/volunteers/signups',
			live: 'convention/volunteers/signups'
		}

	},

	computed: {

		importexportData: function() {

			return {
				columns: {
					status: 'Status',
					reference: 'Reference',
					badgeReference: 'Badge Reference',
					badgeFirstName: 'First Name',
					badgeLastName: 'Last Name',
					badgeEmail: 'E-mail',
					about: 'About',
					dateSubmitted: 'Date Submitted'
				},
				requiredColumns: [],
				valueMapping: [],
				params: {},
				index: this.selectedIndex,
				endpoint: this.$endpoint(this.endpoint)
			}

		}
	
	},

	methods: {

		onAcceptClick: function() {

			this.is.accepting = true

			this.$api.patch('convention/volunteers/signups', {
				index: this.selected,
				action: 'accept'
			}).then(function() {

				this.is.accepting = false

				this.$notify({
					message: 'The selected sign-ups were approved.'
				})

				this.loadRefresh()

			}.bind(this))

		},

		onRejectClick: function() {

			this.is.rejecting = true

			this.$api.patch('convention/volunteers/signups', {
				index: this.selected,
				action: 'reject'
			}).then(function() {

				this.is.rejecting = false

				this.$notify({
					message: 'The selected sign-ups were rejected.'
				})

				this.loadRefresh()

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>